import api from "./axiosInstance";
import axios from "axios";

const buildApiPath = (path) => {
  const baseUrl = process.env.REACT_APP_API_URL;
  if (!baseUrl) {
    return path;
  }
  return `${baseUrl.replace(/\/$/, "")}${path}`;
};

export function fetchUsers() {
  return api.get("/users");
}

export function createUser(user) {
  return api.post("/users", user);
}

export function fetchUserById(id) {
  return api.get(`/users/${id}`);
}

export function fetchUserByUUID(uuid) {
  return api.get(`/users/uuid/${uuid}`);
}

export function registerPublicUser(user) {
  return axios.post(buildApiPath("/users/public"), user); // use axios directly to avoid token injection
}

export function checkNumistrailIdAvailable(id) {
  return axios.get(buildApiPath(`/users/available/${id}`));
}

export function fetchClaimInfo(token) {
  return axios.get(buildApiPath(`/users/claim?token=${encodeURIComponent(token)}`));
}

export function completeClaim(payload) {
  return axios.post(buildApiPath("/users/claim"), payload);
}
